import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RecentDocumentprops } from './Types';

export const recentDocumentApi = createApi({
  reducerPath: 'recentDocumentApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'http://etmf-api-dev-672543026.us-east-2.elb.amazonaws.com/etmf/' }),
  endpoints: builder => ({
    getRecentDocument: builder.query<RecentDocumentprops[], void>({
      query: () => ({
        url: `masterDocument/getAll?is_binder_view=false&user_based_details=true&limit=10`,
        method: 'GET'
      })
    })
  })
});

export const { useGetRecentDocumentQuery } = recentDocumentApi;
